/**
 * Mainbeauty — header của landing: gỡ link trỏ vào phần không in ra (phần trống tự return),
 * tô link của phần đang xem, chạy vạch tiến độ đọc dưới header và bật thanh giữ chỗ dính đáy.
 */

const DOCK_AFTER = 520; // px cuộn trước khi thanh giữ chỗ trượt lên — mốc của bản thiết kế

const nav = document.querySelector("[data-pi-lp-nav]");

if (nav) {
  const links = Array.from(nav.querySelectorAll(".pi-lp-hdr__link")).filter((link) => {
    if (document.getElementById(link.hash.slice(1))) return true;
    link.remove();
    return false;
  });

  const byId = new Map(links.map((link) => [link.hash.slice(1), link]));
  let current = null;

  const activate = (link) => {
    if (link === current) return;
    if (current) current.classList.remove("on");
    current = link;
    if (link) link.classList.add("on");
  };

  // Dải quan sát là khúc giữa màn hình: phần nào đang chiếm khúc đó là phần đang đọc.
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) activate(byId.get(entry.target.id));
      });
    },
    { rootMargin: "-45% 0px -50% 0px" }
  );

  byId.forEach((link, id) => observer.observe(document.getElementById(id)));

  const bar = nav.querySelector("[data-pi-lp-progress]");
  const dock = document.querySelector("[data-pi-lp-dock]");
  const form = document.getElementById("dangky");
  let formInView = false;

  const syncDock = () => {
    if (dock) dock.classList.toggle("is-shown", window.scrollY > DOCK_AFTER && !formInView);
  };

  // Đang nhìn thấy form thì thanh dính đáy rút xuống — không che nút gửi trên mobile.
  if (dock && form) {
    new IntersectionObserver(([entry]) => {
      formInView = entry.isIntersecting;
      syncDock();
    }).observe(form);
  }

  if (bar || dock) {
    let queued = false;
    const paint = () => {
      queued = false;
      const room = document.documentElement.scrollHeight - window.innerHeight;
      // scaleX thay vì width: chỉ compositor vẽ lại, không reflow mỗi lần cuộn.
      if (bar) bar.style.transform = `scaleX(${room > 0 ? Math.min(1, window.scrollY / room) : 0})`;
      syncDock();
    };
    const onScroll = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(paint);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    paint();
  }
}
